import { apiSlice } from './apiSlice';

export const welfareCheckResponseApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getWalkerWelfareCheck: builder.query({
      query: (token) => ({
        url: `/welfare-check/walker/${token}/`,
        method: 'GET',
      }),
    }),
    submitWalkerWelfareCheckResponse: builder.mutation({
      query: ({ token, option }) => ({
        url: `/welfare-check/walker/${token}/`,
        method: 'POST',
        body: { option },
      }),
    }),
    getEmergencyContactWelfareCheck: builder.query({
      query: (token) => ({
        url: `/welfare-check/contact/${token}/`,
        method: 'GET',
      }),
    }),
    submitEmergencyContactWelfareCheckResponse: builder.mutation({
      query: ({ token, option }) => ({
        url: `/welfare-check/contact/${token}/`,
        method: 'POST',
        body: { option },
      }),
    }),
  }),
});

export const {
  useGetWalkerWelfareCheckQuery,
  useSubmitWalkerWelfareCheckResponseMutation,
  useGetEmergencyContactWelfareCheckQuery,
  useSubmitEmergencyContactWelfareCheckResponseMutation,
} = welfareCheckResponseApiSlice;
